import { motion } from "framer-motion";

export default function AboutSection() {
  const stats = [
    { value: "2023", label: "FOUNDED" },
    { value: "AFM", label: "PARENT GROUP" },
    { value: "AI", label: "NATIVE" },
    { value: "100%", label: "RESULTS FIRST" },
  ];

  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-16 md:py-20 bg-black relative overflow-hidden"
    >
      <div className="container mx-auto px-6 md:px-12 max-w-[1400px]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          {/* Left Column */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          >
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-6">
              About Us
            </p>
            <h2 className="font-syne text-4xl sm:text-5xl lg:text-[3.5rem] font-bold leading-[1.1] text-white mb-12">
              A modern{" "}
              <span className="gradient-text">growth</span>
              <br />
              <span className="gradient-text">partner</span> built for
              <br />
              the AI era.
            </h2>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-4">
              {stats.map((stat, index) => (
                <motion.div
                  key={stat.label}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-zinc-950 border border-zinc-800/50 p-6"
                >
                  <p className="font-syne text-2xl md:text-3xl font-bold text-white mb-2">
                    {stat.value}
                  </p>
                  <p className="text-[10px] font-medium uppercase tracking-[0.15em] text-zinc-500">
                    {stat.label}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Right Column - Content */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col justify-center space-y-8"
          >
            {/* Paragraph 1 */}
            <p className="text-base md:text-lg text-zinc-400 leading-relaxed font-light">
              DigiStromer was founded in 2023 with a clear vision: to help businesses grow through smarter marketing, innovative technology, and measurable results. What began as a digital marketing agency quickly evolved into a growth-focused company, combining creative strategy, performance marketing, and data-driven execution to deliver real business impact.
            </p>

            {/* Paragraph 2 */}
            <p className="text-base md:text-lg text-zinc-400 leading-relaxed font-light">
              Today, DigiStromer continues to grow as a modern marketing and technology partner, offering digital marketing services and AI solutions. As a subsidiary of AFM Holding, DigiStromer benefits from the strategic vision and leadership of Chairman Maqsood Mohammed, whose focus on innovation, sustainable growth, and business excellence continues to shape the company's direction.
            </p>

            {/* Paragraph 3 */}
            <p className="text-base md:text-lg text-zinc-400 leading-relaxed font-light">
              Driven by innovation, transparency, and a results-first mindset, DigiStromer helps businesses unlock new growth opportunities while building for the future of digital commerce, AI, and automation.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
